import React from "react";
import "../styles/Product.css";

const Products = () => {
  return (
    <>
    <section className="product-page-banner">
        <div className="banner-overlay">
          <h1>Products we offer</h1>
        </div>
      </section>
    
      <div className="product-header">
            <p>Explore Our Products</p>
            <h1>Bringing You Cutting-Edge Petroleum & Fertilizers Products</h1>
        </div>
    <div className="products-container">

      <div className="column">
        <h2>Petroleum Products</h2>
        <ul>
          <li>DIESEL EN 590 10ppm</li>
          <li>DIESEL EN 590 500ppm</li>
          <li>JET A1</li>
          <li>VIRGIN FUEL D2</li>
          <li>VIRGIN FUEL D6</li>
          <li>Liquefied Natural Gas (LNG)</li>
          <li>Liquefied Petroleum Gas (LPG)</li>
          <li>LIGHT CRUDE OIL</li>
          <li>HEAVY CRUDE OIL</li>
        </ul>
      </div>

      <div className="column">
        <h2>Fertilizers</h2>
        <ul>
          <li>Urea (Granular & Prilled)</li>
          <li>SUPERU™ Stabilized Urea</li>
          <li>Ammonium Nitrate (AN)</li>
          <li>Calcium Ammonium Nitrate (CAN)</li>
          <li>Ammonium Sulphate (AMSUL)</li>
          <li>Urea-Ammonium Nitrate Solution (UAN)</li>
          <li>Diammonium Phosphate (DAP)</li>
          <li>Monoammonium Phosphate (MAP)</li>
          <li>Triple Super Phosphate (TSP)</li>
          <li>Single Super Phosphate (SSP)</li>
          <li>Muriate of Potash (MOP / Potassium Chloride)</li>
          <li>Sulphate of Potash (SOP – Granular)</li>
          <li>Sulphate of Potash (SOP – Standard)</li>
          <li>NPK 16-16-16</li>
          <li>NPK 15-15-15</li>
          <li>Rock Phosphate</li>
          <li>Sulphur</li>
          <li>Sulphuric Acid</li>
        </ul>
      </div>
    </div>
    </>
  );
};

export default Products;